<template>
  <div>
    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="text-center">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>
      </div>
    </div>

    <div class="filtro-component" v-else>
      <b-card>
        <div class="row" id="header-filtro">
          <div
            class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center"
          >
            <h4 class="font-size-16 mb-0" style="font-weight: 600">
              FILTRO DE PROJETOS
            </h4>
          </div>

          <div
            class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end order-1 order-md-2 mb-2 mb-md-0"
          >
            <b-button
              @click.stop="importarCSV"
              variant="warning"
              class="me-md-3 mb-2 mb-md-0"
              ><i class="fa fa-solid fa-upload"></i> Importar CSV</b-button
            >
            <b-button @click.stop="novoProjeto" variant="success"
              ><i class="fa fa-solid fa-plus"></i> Novo Projeto</b-button
            >
          </div>
        </div>

        <!-- Conteúdo do filtro -->
        <div class="mt-3">
          <hr />
          <div class="row">
            <!-- Cooperado -->
            <div class="col-md-3 mb-3">
              <b-form-group
                label="Cooperado"
                :state="getState('selecaoCooperado')"
                invalid-feedback="O campo cooperado é obrigatório"
              >
                <multiselect
                  label="name"
                  track-by="name"
                  :max-height="200"
                  :taggable="false"
                  :allowEmpty="false"
                  :disabled="cooperadoDisabled"
                  placeholder="Selecione um cooperado"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :options="cooperadoLkp"
                  v-model="selecaoCooperadoVM"
                  @input="carregarClienteRural"
                >
                  <span slot="noResult">Nenhum cooperado encontrado</span>
                  <span slot="noOptions">Nenhum cooperado disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Cliente Rural -->
            <div class="col-md-3 mb-3">
              <b-form-group label="Cliente Rural">
                <multiselect
                  v-model="selecaoClienteRuralVM"
                  :options="clienteRuralLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione um cliente rural"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :loading="loadingClienteRural"
                  :max-height="200"
                >
                  <span slot="noResult">Nenhum cliente rural encontrado</span>
                  <span slot="noOptions">Nenhum cliente rural disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Instituição Financeira -->
            <div class="col-md-3 mb-3">
              <b-form-group label="Instituição Financeira">
                <multiselect
                  v-model="selecaoInstituicaoFinanceiraVM"
                  :loading="loadingInstFinanceira"
                  :options="instituicaoFinanceiraLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione uma instituição"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :max-height="200"
                >
                  <span slot="noOptions">
                    Nenhuma instituição financeira disponível
                  </span>
                  <span slot="noResult">
                    Nenhuma instituição financeira encontrada
                  </span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Linha de Crédito -->
            <div class="col-md-3 mb-3">
              <b-form-group label="Linha de Crédito">
                <multiselect
                  v-model="selecaoLinhaCreditoVM"
                  :options="linhaCreditoLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione uma linha de crédito"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :max-height="200"
                >
                  <span slot="noOptions">
                    Nenhuma linha de crédito disponível
                  </span>
                  <span slot="noResult">
                    Nenhuma linha de crédito encontrada
                  </span>
                </multiselect>
              </b-form-group>
            </div>
          </div>

          <!-- Safra, Tipo de Projeto, Item Agropecuário, N° Projeto -->
          <div class="row d-flex mb-1">
            <!-- Safra -->
            <div class="col-md-3">
              <b-form-group label="Safra">
                <multiselect
                  label="name"
                  track-by="name"
                  :max-height="200"
                  v-model="selecaoSafraVM"
                  placeholder="Selecione uma safra"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :options="selecaoSafraLkp"
                  @input="carregarItemAgropecuario"
                  :class="{
                    'is-invalid': safraObrigatoria,
                    'border-danger': safraObrigatoria
                  }"
                >
                  <span slot="noResult">Nenhuma safra encontrada</span>
                  <span slot="noOptions">Nenhuma safra disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Tipo de Projeto -->
            <div class="col-md-3 mb-3">
              <b-form-group label="Tipo de Projeto">
                <multiselect
                  v-model="selecaoTipoProjetoVM"
                  :options="tipoProjetoLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione um tipo de projeto"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  @input="carregarItemAgropecuario"
                  :max-height="200"
                  :class="{ 'is-invalid': tpProjetoObrigatorio }"
                >
                  <span slot="noOptions">
                    Nenhum tipo de projeto disponível
                  </span>
                  <span slot="noResult">
                    Nenhum tipo de projeto encontrado
                  </span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Item Agropecuário -->
            <div class="col-md-3 mb-3">
              <b-form-group label="Item Agropecuário">
                <multiselect
                  v-model="selecaoItemAgropecuarioVM"
                  :options="itemAgropecuarioLkp"
                  :loading="loadingItemAgropecuario"
                  label="name"
                  track-by="name"
                  placeholder="Selecione um item agropecuário"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :max-height="200"
                  @open="validaSafraTpProjetoObrigatorio"
                  @close="
                    safraObrigatoria = false;
                    tpProjetoObrigatorio = false;
                  "
                >
                  <span slot="noOptions">
                    Lista vazia, selecione a safra e tipo de projeto.
                  </span>
                  <span slot="noResult">
                    Nenhum item agropecuário encontrado
                  </span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- N° Projeto -->
            <div class="col-md-3 mb-3">
              <b-form-group label="N° Projeto">
                <b-form-input
                  v-model="numeroProjetoVM"
                  v-mask="'########'"
                  :maxlength="8"
                  type="text"
                  placeholder="Digite o número do projeto"
                />
              </b-form-group>
            </div>
          </div>

          <!-- Projeto Unicampo, Município, Modalidade, Status -->
          <div class="row d-flex mb-1">
            <!-- Projeto Unicampo -->
            <div class="col-md-3">
              <b-form-group label="Projeto Unicampo">
                <multiselect
                  v-model="selecaoProjetoVM"
                  :options="selecaoProjetoLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione um projeto"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :max-height="150"
                >
                  <span slot="noResult">Nenhum projeto encontrado</span>
                  <span slot="noOptions">Nenhum projeto disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Município - UF -->
            <div class="col-md-3">
              <b-form-group label="Município - UF">
                <multiselect
                  v-model="selecaoMunicipioVM"
                  :options="selecaoMunicipioLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione um município"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :max-height="150"
                >
                  <span slot="noResult">Nenhum município encontrado</span>
                  <span slot="noOptions">Nenhum município disponível</span>
                </multiselect>
              </b-form-group>
            </div>

            <!-- Modalidade do Seguro -->
            <div class="col-md-3">
              <b-form-group label="Modalidade do Seguro">
                <multiselect
                  v-model="selecaoModalidadeSeguroVM"
                  :options="selecaoModalidadeSeguroLkp"
                  label="name"
                  track-by="name"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  placeholder="Selecione uma modalidade de seguro"
                  :max-height="150"
                >
                  <span slot="noResult"
                    >Nenhuma modalidade de seguro encontrada</span
                  >
                  <span slot="noOptions"
                    >Nenhuma modalidade de seguro disponível</span
                  >
                </multiselect>
              </b-form-group>
            </div>

            <!-- Status -->
            <div class="col-md-3">
              <b-form-group label="Status">
                <multiselect
                  v-model="selecaoStatusProjetoVM"
                  :options="selecaoStatusProjetoLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione um status"
                  selected-label=""
                  deselect-label=""
                  select-label=""
                  :max-height="150"
                >
                  <span slot="noResult">Nenhum status encontrado</span>
                  <span slot="noOptions">Nenhum status disponível</span>
                </multiselect>
              </b-form-group>
            </div>
          </div>

          <!-- Botões Limpar / Filtrar -->
          <div class="row pb-2 mt-3">
            <div
              class="col-md-6 col-sm-12 d-flex flex-column flex-md-row gap-2 mb-2 mb-md-0 order-2 order-md-1"
            >
              <b-button
                variant="secondary"
                class="mb-2 mb-md-0"
                @click="limpar"
              >
                <i class="mdi mdi-broom me-1"></i>
                <span>Limpar</span>
              </b-button>

              <b-button
                variant="primary"
                class="btn-filtrar"
                @click="clicarParaFiltrar"
                :disabled="disabledFiltro"
              >
                <div v-if="!disabledFiltro">
                  <i class="mdi mdi-filter-outline me-1"></i>
                  <span>Filtrar</span>
                </div>
                <b-spinner
                  small
                  variant="white"
                  v-if="disabledFiltro"
                ></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
      </b-card>
    </div>

    <!-- Modais -->
    <modalImportacao
      ref="modalImportacao"
      @errosImportacao="mostrarErrosImportacao"
    />
    <modalErrosImportacao ref="modalErrosImportacao" :erros="errosImportacao" />
    <ModalInfoFiltro :isOpenModal.sync="showModal" />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ModalInfoFiltro from "./ModalInfoFiltro.vue";
import { required } from "vuelidate/lib/validators";
import { filtrosProjetosHelper } from "@/store/helpers/vuex/astec";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { paginacaoProjetosHelper } from "@/store/helpers/vuex/astec";
import modalImportacao from "@/components/astec/projetos/lotesImportacao/modalImportacao";
import modalErrosImportacao from "@/components/astec/projetos/lotesImportacao/modalErrosImportacao";

export default {
  name: "FiltroProjetos",
  mixins: [clienteRuralMixin],
  components: {
    Multiselect,
    modalImportacao,
    modalErrosImportacao,
    ModalInfoFiltro
  },

  data() {
    return {
      submit: false,
      loading: true,
      showModal: false,
      clienteRuralLkp: [],
      instituicaoFinanceiraLkp: [],
      linhaCreditoLkp: [],
      tipoProjetoLkp: [],
      selecaoSafraLkp: [],
      selecaoMunicipioLkp: [],
      selecaoProjetoLkp: [],
      itemAgropecuarioLkp: [],
      selecaoStatusProjetoLkp: [],
      selecaoModalidadeSeguroLkp: [],
      cooperadoLkp: [],
      loadingInstFinanceira: false,
      cdPessoa: "",
      disabledFiltro: false,
      loadingItemAgropecuario: false,
      loadingClienteRural: false,
      errosImportacao: null,
      safraObrigatoria: false,
      tpProjetoObrigatorio: false,
      filtroClicadoPeloBotao: false
    };
  },

  watch: {
    changeData: {
      handler() {
        this.emitrDadosFiltroRelatorio();
      },
      deep: true
    }
  },

  computed: {
    ...filtrosProjetosHelper({
      state: [
        "selecaoCooperado",
        "selecaoClienteRural",
        "selecaoInstituicaoFinanceira",
        "selecaoLinhaCredito",
        "selecaoSafra",
        "selecaoTipoProjeto",
        "selecaoItemAgropecuario",
        "selecaoProjeto",
        "selecaoMunicipio",
        "selecaoModalidadeSeguro",
        "selecaoStatusProjeto",
        "numeroProjeto",
        "cdPessoa"
      ],
      getters: ["filtroProjetos", "hasFiltrosAtivos"],
      actions: []
    }).computed,

    selecaoCooperadoVM: {
      get() {
        return this.selecaoCooperado;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoCooperado", valor: val });
      }
    },

    selecaoClienteRuralVM: {
      get() {
        return this.selecaoClienteRural;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoClienteRural", valor: val });
      }
    },

    selecaoInstituicaoFinanceiraVM: {
      get() {
        return this.selecaoInstituicaoFinanceira;
      },
      set(val) {
        this.setFiltroCampo({
          campo: "selecaoInstituicaoFinanceira",
          valor: val
        });
      }
    },

    selecaoLinhaCreditoVM: {
      get() {
        return this.selecaoLinhaCredito;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoLinhaCredito", valor: val });
      }
    },

    selecaoSafraVM: {
      get() {
        return this.selecaoSafra;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoSafra", valor: val });
      }
    },

    selecaoTipoProjetoVM: {
      get() {
        return this.selecaoTipoProjeto;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoTipoProjeto", valor: val });
      }
    },

    selecaoItemAgropecuarioVM: {
      get() {
        return this.selecaoItemAgropecuario;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoItemAgropecuario", valor: val });
      }
    },

    selecaoProjetoVM: {
      get() {
        return this.selecaoProjeto;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoProjeto", valor: val });
      }
    },

    selecaoMunicipioVM: {
      get() {
        return this.selecaoMunicipio;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoMunicipio", valor: val });
      }
    },

    selecaoModalidadeSeguroVM: {
      get() {
        return this.selecaoModalidadeSeguro;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoModalidadeSeguro", valor: val });
      }
    },

    selecaoStatusProjetoVM: {
      get() {
        return this.selecaoStatusProjeto;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoStatusProjeto", valor: val });
      }
    },

    numeroProjetoVM: {
      get() {
        return this.numeroProjeto;
      },
      set(val) {
        this.setFiltroCampo({ campo: "numeroProjeto", valor: val });
      }
    },

    cooperadoDisabled() {
      return this.cooperadoLkp.length === 1;
    },

    changeData() {
      const {
        selecaoSafra,
        selecaoCooperado,
        selecaoTipoProjeto,
        selecaoStatusProjeto,
        selecaoItemAgropecuario,
        selecaoInstituicaoFinanceira
      } = this;
      return {
        selecaoSafra,
        selecaoCooperado,
        selecaoTipoProjeto,
        selecaoStatusProjeto,
        selecaoItemAgropecuario,
        selecaoInstituicaoFinanceira
      };
    }
  },

  async mounted() {
    await this.buscarDados();

    this.$store.commit("PARAMETROS_FILTRO_PROJETO_ASTEC", null);

    const statusElaborado = this.selecaoStatusProjetoLkp.find(
      el => el.value === "E"
    );

    this.selecaoStatusProjetoVM = statusElaborado;

    await this.emitirFiltro(false);
    this.submit = false;
    this.$v.$reset();
  },

  methods: {
    ...filtrosProjetosHelper({
      state: [],
      getters: [],
      actions: ["setFiltroProjetos", "setFiltroCampo", "limparFiltrosProjetos"]
    }).methods,

    ...paginacaoProjetosHelper({
      actions: ["resetarPaginacao"]
    }).methods,

    clicarParaFiltrar() {
      this.filtroClicadoPeloBotao = true;
      this.emitirFiltro();
    },

    getState(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      }
      return null;
    },

    async buscarDados() {
      await this.getNomeRazaoUsuario();
      await this.buscarMunicipioUf();
      await this.buscarLkpProjeto();
      await this.buscarLkpSafra();
      await this.buscarLkpLinhaCredito();
      await this.buscarLkpTipoProjeto();
      await this.buscarLkpModalidadeSeguro();
      await this.buscarLkpStatusProjeto();
      await this.buscarLkpCooperado();
      await this.verificarCooperado();
      await this.carregarClienteRural();

      this.emitirFiltro();
      this.loading = false;
    },

    async carregarClienteRural() {
      if (this.selecaoCooperado) {
        this.clienteRuralLkp = [];
        this.selecaoClienteRural = null;
        this.loadingClienteRural = true;

        try {
          const response = await this.$http.get(
            "/api/astec/getLkpClienteRuralProjetos/" +
              this.selecaoCooperado.value
          );

          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name: cliente.DISPLAY,
              value: cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ
            };
          });
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }

        this.loadingClienteRural = false;
        this.carregarInstFinanceira();
      }
    },

    async verificarFiltro(filtro) {
      this.selecaoCooperado = this.cooperadoLkp.find(
        el => el.value == filtro.cdCooperado
      );

      await this.carregarClienteRural();

      this.selecaoClienteRural = this.clienteRuralLkp.find(
        el => el.value == filtro.sqCliente
      );

      this.selecaoLinhaCredito = this.linhaCreditoLkp.find(
        el => el.value == filtro.cdLinhaCredito
      );

      this.selecaoTipoProjeto = this.tipoProjetoLkp.find(
        el => el.value == filtro.sqTpProjeto
      );

      this.selecaoSafra = this.selecaoSafraLkp.find(
        el => `'${el.name}'` == filtro.cdSafra
      );

      this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
        el => el.value == filtro.cdItemAgropecuario
      );

      this.selecaoModalidadeSeguro = this.selecaoModalidadeSeguroLkp.find(
        el => el.value == filtro.sqModalidadeSeguro
      );

      this.selecaoStatusProjeto = this.selecaoStatusProjetoLkp.find(
        el => `'${el.value}'` == filtro.stProjeto
      );

      this.numeroProjeto = filtro.nrProjeto || "";

      this.selecaoProjeto = this.selecaoProjetoLkp.find(
        el => el.value == filtro.cdProjeto
      );

      this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
        el => el.value == filtro.sqRegiao
      );

      if (this.selecaoCooperado) {
        await this.carregarInstFinanceira();

        this.selecaoInstituicaoFinanceira = this.instituicaoFinanceiraLkp.find(
          el => el.value == filtro.cdInstituicaoFinanceira
        );
      }

      if (this.selecaoTipoProjeto && this.selecaoSafra) {
        await this.carregarItemAgropecuario();

        this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
          el => el.value == filtro.cdItemAgropecuario
        );
      }

      // Salva todos os filtros no Vuex
      const filtrosParaSalvar = {
        selecaoCooperado: this.selecaoCooperado,
        selecaoClienteRural: this.selecaoClienteRural,
        selecaoInstituicaoFinanceira: this.selecaoInstituicaoFinanceira,
        selecaoLinhaCredito: this.selecaoLinhaCredito,
        selecaoSafra: this.selecaoSafra,
        selecaoTipoProjeto: this.selecaoTipoProjeto,
        selecaoItemAgropecuario: this.selecaoItemAgropecuario,
        selecaoProjeto: this.selecaoProjeto,
        selecaoMunicipio: this.selecaoMunicipio,
        selecaoModalidadeSeguro: this.selecaoModalidadeSeguro,
        selecaoStatusProjeto: this.selecaoStatusProjeto,
        numeroProjeto: this.numeroProjeto
      };

      this.setFiltroProjetos(filtrosParaSalvar);
      this.emitirFiltro(false);
    },

    async verificarCooperado() {
      await this.$nextTick();

      if (this.cooperadoLkp && this.cooperadoLkp.length === 1) {
        this.selecaoCooperadoVM = this.cooperadoLkp[0];
        await this.carregarClienteRural();
        await this.carregarInstFinanceira();
      } else if (
        this.cdPessoa &&
        this.cooperadoLkp &&
        this.cooperadoLkp.length > 0
      ) {
        const cooperadoEncontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.cdPessoa
        );

        if (cooperadoEncontrado) {
          this.selecaoCooperadoVM = cooperadoEncontrado;
          await this.carregarInstFinanceira();
        }
      }
    },

    limpar() {
      this.setFiltroProjetos({
        selecaoClienteRural: null,
        selecaoInstituicaoFinanceira: null,
        selecaoLinhaCredito: null,
        selecaoSafra: null,
        selecaoTipoProjeto: null,
        selecaoItemAgropecuario: null,
        selecaoProjeto: null,
        selecaoMunicipio: null,
        selecaoModalidadeSeguro: null,
        selecaoStatusProjeto: null,
        numeroProjeto: ""
      });

      this.clienteRuralLkp = [];
      this.instituicaoFinanceiraLkp = [];
      this.itemAgropecuarioLkp = [];

      this.submit = false;
      this.$v.$reset();
      this.$store.commit("PARAMETROS_FILTRO_PROJETO_ASTEC", null);
      this.$emit("projetoAstecFiltrados", null);
    },

    async emitirFiltro() {
      this.submit = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      if (!this.selecaoCooperado) {
        this.$bvToast.toast("Selecione um cooperado para filtrar os projetos", {
          title: "Atenção",
          variant: "warning",
          solid: true
        });
        return;
      }

      if (this.filtroClicadoPeloBotao) {
        await this.resetarPaginacao();
        this.filtroClicadoPeloBotao = false;
      }

      this.disabledFiltro = true;
      this.safraObrigatoria = false;

      await this.$nextTick();

      const filtro = this.montarObjetoFiltro();

      const valido = this.selecionaDadosFiltro(filtro);
      if (!valido) {
        this.disabledFiltro = false;
        return;
      }

      this.$store.commit("PARAMETROS_FILTRO_PROJETO_ASTEC", filtro);
      this.emitrDadosFiltroRelatorio();

      this.$emit("projetoAstecFiltrados", filtro, () => {
        this.disabledFiltro = false;
      });
    },

    async emitrDadosFiltroRelatorio() {
      const dadosFiltroRelatorio = {
        safra: this.selecaoSafra ? { ...this.selecaoSafra } : null,
        cooperado: this.selecaoCooperado ? { ...this.selecaoCooperado } : null,
        status: this.selecaoStatusProjeto
          ? { ...this.selecaoStatusProjeto }
          : null,
        tipoProjeto: this.selecaoTipoProjeto
          ? { ...this.selecaoTipoProjeto }
          : null,
        banco: this.selecaoInstituicaoFinanceira
          ? { ...this.selecaoInstituicaoFinanceira }
          : null,
        itemAgropecuario: this.selecaoItemAgropecuario
          ? { ...this.selecaoItemAgropecuario }
          : null
      };
      try {
        await this.$store.dispatch(
          "astec/projetos/filtros/setFiltroCompleto",
          dadosFiltroRelatorio
        );
      } catch (error) {
        console.error("Erro ao enviar filtro para Vuex:", error);
      }
    },

    async carregarInstFinanceira() {
      if (!this.selecaoCooperado?.value) {
        return;
      }

      this.instituicaoFinanceiraLkp = [];
      this.selecaoInstituicaoFinanceira = null;
      this.loadingInstFinanceira = true;

      try {
        await this.buscarLkpInstituicaoFinanc(this.selecaoCooperado.value);
      } catch (error) {
        this.$tools.alerta(
          "Erro ao carregar instituições financeiras",
          "error"
        );
      } finally {
        this.loadingInstFinanceira = false;
      }
    },

    montarObjetoFiltro() {
      const dados = {
        sqCliente: this.selecaoClienteRural
          ? this.selecaoClienteRural.value
          : null,
        sqRegiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cdProjeto: this.selecaoProjeto ? this.selecaoProjeto.value : null,
        cdSafra: this.selecaoSafra ? `'${this.selecaoSafra.name}'` : null,
        cdInstituicaoFinanceira: this.selecaoInstituicaoFinanceira
          ? this.selecaoInstituicaoFinanceira.value
          : null,
        cdLinhaCredito: this.selecaoLinhaCredito
          ? this.selecaoLinhaCredito.value
          : null,
        sqTpProjeto: this.selecaoTipoProjeto
          ? this.selecaoTipoProjeto.value
          : null,
        cdItemAgropecuario: this.selecaoItemAgropecuario
          ? this.selecaoItemAgropecuario.value
          : null,
        sqModalidadeSeguro: this.selecaoModalidadeSeguro
          ? this.selecaoModalidadeSeguro.value
          : null,
        stProjeto: this.selecaoStatusProjeto
          ? `'${this.selecaoStatusProjeto.value}'`
          : null,
        cdCooperado: this.selecaoCooperado ? this.selecaoCooperado.value : null,
        nrProjeto: this.numeroProjeto ? this.numeroProjeto : null
      };

      return dados;
    },

    async carregarItemAgropecuario() {
      if (this.selecaoTipoProjeto && this.selecaoSafra) {
        this.selecaoItemAgropecuario = null;
        this.loadingItemAgropecuario = true;

        try {
          const response = await this.$http.get(
            "/api/astec/getLkpItemAgropecuario/" +
              this.selecaoTipoProjeto.value +
              "/" +
              this.selecaoSafra.epoca
          );

          this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
            name: itemAgropecuario.DISPLAY,
            value: itemAgropecuario.ID
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }

        this.loadingItemAgropecuario = false;
      } else {
        this.selecaoItemAgropecuario = null;
        this.itemAgropecuarioLkp = [];
      }

      return;
    },

    importarCSV() {
      const selectedCooperative = this.selecaoCooperado;
      if (!selectedCooperative?.value) {
        this.$refs.modalImportacao.abrirModal();
        return;
      }
      const importCooperative = {
        name: selectedCooperative.name,
        value: selectedCooperative.value
      };

      this.$refs.modalImportacao.abrirModal(importCooperative);
    },

    mostrarErrosImportacao(errosImportacao) {
      this.errosImportacao = errosImportacao;

      this.$refs.modalErrosImportacao.abrirModalErrosImport();
    },

    novoProjeto() {
      localStorage.setItem("exibirCamposImportacao", false);
      this.$router.push("/astec/projetos/novoProjeto");
    },

    validaSafraTpProjetoObrigatorio() {
      if (this.selecaoSafra != null) {
        this.safraObrigatoria = false;
      } else {
        this.safraObrigatoria = true;
      }

      if (this.selecaoTipoProjeto != null) {
        this.tpProjetoObrigatorio = false;
      } else {
        this.tpProjetoObrigatorio = true;
      }
    },

    destacarCampoSafra() {
      this.safraObrigatoria = true;
    },

    selecionaDadosFiltro(dadosFiltro) {
      const {
        cdSafra,
        sqRegiao,
        cdProjeto,
        sqCliente,
        stProjeto,
        nrProjeto,
        sqTpProjeto,
        cdLinhaCredito,
        cdItemAgropecuario,
        sqModalidadeSeguro,
        cdInstituicaoFinanceira
      } = dadosFiltro;

      const filtroLimpo = {
        cdSafra,
        sqRegiao,
        sqCliente,
        cdProjeto,
        stProjeto,
        nrProjeto,
        sqTpProjeto,
        cdLinhaCredito,
        cdItemAgropecuario,
        sqModalidadeSeguro,
        cdInstituicaoFinanceira
      };

      const filtroSemDados = Object.values(filtroLimpo).every(el => el == null);

      if (filtroSemDados) {
        this.showModal = true;
        return false;
      }

      return true;
    }
  },

  validations: {
    selecaoCooperado: { required }
  }
};
</script>

<style lang="css" scoped>
:deep(.multiselect.border-danger) {
  border: 2px solid #dc3545 !important;
  border-radius: 6px;
  animation: pulse-danger 1.5s infinite;
}

:deep(.multiselect.border-danger .multiselect__tags) {
  border: 2px solid #dc3545 !important;
  background-color: #fff5f5 !important;
  border-radius: 6px;
}

:deep(.multiselect.border-danger .multiselect__placeholder) {
  color: #dc3545 !important;
  font-weight: 500;
}

:deep(.multiselect.border-danger .multiselect__single) {
  color: #dc3545 !important;
  font-weight: 500;
}

@keyframes pulse-danger {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}

.filtro-expandido-com-erro {
  border-left: 4px solid #dc3545 !important;
}

.btn-filtrar {
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
